import { Box, TextField, Button } from '@mui/material';
import { Field, Form, FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';
import GlobalSelectField from '../../../../../../../components/mui/GlobalSelectField';
import { TOTAL_MARKS } from '../util/TotalMarsk';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../../../../Hooks/useHandleApiResponse';
import {
  getAssessmentDetailsType,
  postDuplicateAssessmentDetails,
  putAssessmentDetails,
} from '../../../../../../../redux/features/CRDslice';
// import { useDispatch } from 'react-redux';
// import { getAssessmentDetailsType } from '../../../../../../../redux/features/CRDslice';
import { useSelector } from 'react-redux';

export default function EditAssessmentDetails({ rowData, dispatchParams, dispatchFn, setOpenModalName, duplicate }) {
  const { loading, assessmentDetailsTypes } = useSelector((state) => state.crd);

  const dispatch = useDispatch();
  const apiHandler = useHandleApiResponse();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      student_examination_id: rowData?.student_examination_id,
      subject_enrollment_id: rowData?.subject_enrollment_id,
      trainer_assignment_id: rowData?.trainer_assignment_id,
      student_examination_type_id: rowData?.student_examination_type_id,
      examination_date: rowData?.examination_date,
      total_marks: rowData?.total_marks,
      marks_obtained: rowData?.marks_obtained,
      examinationType: rowData?.examinationType,
      studentName: rowData?.studentName,
      className: rowData?.className,
      courseName: rowData?.courseName,
      subjectName: rowData?.subjectName,
      croName: rowData?.croName,
      // auto
      obtainedPercentage: '',
      // changable
      handwriting_rating: Number(rowData?.handwriting_rating) ?? '',
      student_engagement_rating: Number(rowData?.student_engagement_rating) ?? '',
      extra_curricular_activities_rating: Number(rowData?.extra_curricular_activities_rating) ?? '',
      attendance_rating: Number(rowData?.attendance_rating) ?? '',
      punctuality_rating: Number(rowData?.punctuality_rating) ?? '',
      // suggestions: '',
      tutor_suggestions: null,
      exam_upload_file: null,
    },
    onSubmit: (values) => {
      dispatch(duplicate ? postDuplicateAssessmentDetails(values) : putAssessmentDetails(values)).then((res) =>
        apiHandler(res, {
          onSuccess: () => {
            dispatch(dispatchFn(dispatchParams));
            setOpenModalName(false);
          },
        }),
      );
    },
  });

  useEffect(() => {
    dispatch(getAssessmentDetailsType({ isHour: Boolean(rowData?.isHour), total_sessions: rowData?.totalSessions }));
  }, [rowData, dispatch]);

  const { values, setFieldValue } = formik;

  const handleChangeOutOfTen = (e, name) => {
    const value = e.target.value;
    if (value > 10) setFieldValue(name, 10);
    else setFieldValue(name, value);
  };

  useEffect(() => {
    const { total_marks, marks_obtained } = values;

    if (total_marks && marks_obtained !== '') {
      const percentage = (Number(marks_obtained) / Number(total_marks)) * 100;

      setFieldValue('obtainedPercentage', percentage.toFixed(2));
    } else {
      setFieldValue('obtainedPercentage', '');
    }
  }, [values.total_marks, values.marks_obtained, setFieldValue]);

  const DISABLED_FIELDS = [
    { label: 'Exam Type', value: 'examinationType' },
    { label: 'Student', value: 'studentName' },
    { label: 'Class', value: 'className' },
    { label: 'Course', value: 'courseName' },
    { label: 'Subject', value: 'subjectName' },
    { label: 'CRO', value: 'croName' },
  ];
  const PostAssessmentExtraField = [
    {
      label: 'Student Engagement (out of 10)',
      value: 'student_engagement_rating',
    },
    {
      label: 'Extra Curricular Activities (out of 10)',
      value: 'extra_curricular_activities_rating',
    },
    {
      label: 'Attendance (out of 10)',
      value: 'attendance_rating',
    },
    {
      label: 'Punctuality (out of 10)',
      value: 'punctuality_rating',
    },
  ];

  return (
    <FormikProvider value={formik}>
      <Form>
        <Box display="grid" gap={2} minWidth={{ sm: '100%', md: 600 }}>
          {Boolean(duplicate) && (
            <GlobalSelectField
              options={{
                formik,
                label: 'New Exam Type',
                keys: {
                  id: 'student_examination_type_id',
                  value: 'student_examination_type_name',
                },
                name: 'student_examination_type_id',
                data: assessmentDetailsTypes,
                sx: {
                  width: '100%',
                },
              }}
            />
          )}{' '}
          {DISABLED_FIELDS.map(({ label, value }, i) => (
            <TextField label={label} value={values?.[value]} disabled key={i} />
          ))}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={'Examination Date'}
              value={dayjs(values.examination_date)}
              onChange={(value) => setFieldValue('examination_date', value.format('YYYY-MM-DD'))}
            />
          </LocalizationProvider>
          <GlobalSelectField
            options={{
              formik,
              label: 'Total Marks',
              keys: {
                id: 'id',
                value: 'value',
              },
              name: 'total_marks',
              data: TOTAL_MARKS,
              setFieldName: 'value',
            }}
          />
          <Field
            as={TextField}
            label="Marks Obtained"
            name="marks_obtained"
            type="number"
            onWheel={(e) => e.target.blur()}
          />
          <TextField label="Obtained Percentage (%)" value={values.obtainedPercentage} disabled />
          <Field
            as={TextField}
            label="Rate Handwriting (out of 10)"
            name="handwriting_rating"
            type="number"
            onChange={(e) => handleChangeOutOfTen(e, 'handwriting_rating')}
            onWheel={(e) => e.target.blur()}
          />
          {rowData?.examinationType === 'Post Assessment' ||
            (assessmentDetailsTypes?.some(
              (e) =>
                e?.student_examination_type_id === formik.values.student_examination_type_id &&
                e?.student_examination_type_name === 'Post Assessment',
            ) &&
              PostAssessmentExtraField.map(({ label, value }, i) => (
                <Field
                  as={TextField}
                  name={value}
                  label={label}
                  onChange={(e) => handleChangeOutOfTen(e, value)}
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  key={i}
                />
              )))}
          {/* <Field as={TextField} label="Suggestions (Optional)" name="suggestions" multiline rows={3} /> */}
          <Button
            type="submit"
            variant="contained"
            disabled={
              loading || duplicate
                ? formik.values.student_examination_type_id === rowData?.student_examination_type_id
                : false
            }
          >
            {loading ? 'submitting...' : 'submit'}
          </Button>
        </Box>
      </Form>
    </FormikProvider>
  );
}
